import { Select } from "antd"
import React from "react"

interface MetadataOption {
  label: string
  value: string
}

interface MetadataSelectProps {
  value: string | null | undefined
  options: MetadataOption[]
  placeholder: string
  loadFailedText?: string
  disabled?: boolean
  size?: "small" | "middle"
  className?: string
  autoFocus?: boolean
  /** Forces the dropdown open — the Details panel's "click Edit to reveal" pattern. */
  open?: boolean
  onBlur?: () => void
  onChange: (value: string | null) => void
  ariaLabel?: string
}

/**
 * One Select configuration for every place a document's Status or Document
 * Type can be changed (the File List's always-visible cell, the Details
 * panel's click-to-edit row) — so there is exactly one status-editing and
 * one document-type-editing implementation, not a second one per surface.
 */
export function MetadataSelect({
  value,
  options,
  placeholder,
  loadFailedText,
  disabled,
  size,
  className,
  autoFocus,
  open,
  onBlur,
  onChange,
  ariaLabel
}: MetadataSelectProps) {
  return (
    <Select<string>
      allowClear
      showSearch
      autoFocus={autoFocus}
      open={open}
      size={size}
      disabled={disabled}
      value={value ?? undefined}
      options={options}
      optionFilterProp="label"
      placeholder={placeholder}
      notFoundContent={loadFailedText}
      onBlur={onBlur}
      onChange={(next) => onChange(next ?? null)}
      className={className}
      aria-label={ariaLabel}
    />
  )
}
